import { InjectionToken } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';

export const WINDOW_TOKEN = new InjectionToken<Window>('Window', {
  factory: () => window,
});

export const SENTRY_TOKEN = new InjectionToken<typeof Sentry>('Sentry', {
  factory: () => Sentry,
});
